import config from '../config';
import { getAuth, OAuthProvider } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { ReactNode } from 'react';
import { CustomProvider, initializeAppCheck } from 'firebase/app-check';
import { CloudflareProviderOptions } from './turnstile';

export const firebaseApp = initializeApp(config.firebaseConfig);

const siteKey = '0x4AAAAAABNtPu2r7QAA3XLP';

const HTTP_ENDPOINT =
  'https://run.medely.com/app-check-provider';

const cpo = new CloudflareProviderOptions(HTTP_ENDPOINT, siteKey);

if (process.env.REACT_APP_RELEASE_STAGE === 'production') {
  const provider = new CustomProvider(cpo);
  initializeAppCheck(firebaseApp, { provider });
}

export const auth = getAuth(firebaseApp);
export const provider = new OAuthProvider('oidc.medely-okta');
provider.addScope?.('openid');
provider.addScope?.('email');
provider.addScope?.('profile');
provider.setCustomParameters?.({ prompt: 'select_account' });

export type BaseContextArgs = { children: ReactNode | ReactNode[] };

export { cpo as turnstile };
